import { httpClient } from "./common";
import { ResponseData } from "./types";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class UserNotificationsAPI {
  private static readonly API_URL = "/user_notifications";

  static async getUserNotifications(): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.get(UserNotificationsAPI.API_URL, true);
    }, "Error al obtener las notificaciones del usuario");
  }

  static async markAsRead(notificationId: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.patch(
        `${UserNotificationsAPI.API_URL}/${notificationId}/read`,
        undefined,
        true
      );
    }, "Error al marcar la notificación como leída");
  }

  static async deleteNotification(
    notificationId: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.delete(
        `${UserNotificationsAPI.API_URL}/${notificationId}`,
        true
      );
    }, "Error al eliminar la notificación");
  }

  static async sendTeamNotification(
    teamId: number,
    notificationType:
      | "missing_members"
      | "missing_helmsman"
      | "missing_boat"
      | "payment_due"
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(async () => {
      return await httpClient.post(
        `${UserNotificationsAPI.API_URL}/teams/${teamId}`,
        { notification_type: notificationType },
        true
      );
    }, "Error al enviar la notificación del equipo");
  }
}
